import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import FeedbackSurveySubmitButton from './FeedbackSurveySubmitButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackSurveyFooter = ({
  confirmText,
  followUp,
  onConfirm,
  onReject,
  rejectText,
  surveyConfig
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "300",
    children: [/*#__PURE__*/_jsx(FeedbackSurveySubmitButton, {
      followUp: followUp,
      onClick: onConfirm,
      surveyConfig: surveyConfig,
      children: confirmText
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "survey-reject-button",
      onClick: onReject,
      size: "sm",
      use: "tertiary-light",
      children: rejectText
    })]
  });
};
export default FeedbackSurveyFooter;